/*
* 直接用kaXTC()，来获取定制化部署的租户行为，tenantCheckData参数是为了兼容历史代码
*/
export function kaXTC(tenantCheckData: any = {}) {
  return process.env.CUSTOMIZED_PROJECT === 'xtc' || tenantCheckData.isXTC;
}
